module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_8.c3a9484896ddd949b940a78064f93c39.png";